/**
 * Model "class" for Practitioner - defines useful field metadata for building and validating forms
 */

import * as _ from 'lodash'
import { required, helpers } from 'vuelidate/lib/validators'
import Api from '@/providers/Api'

// custom validator for phone numbers
const phoneNumber = (value) => {
    return !helpers.req(value) || value == '' || /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/.test(value)
}

export default {
    fields: {
        email: {
            label: 'FIELD_USER_EMAIL',
            type: 'email',
            validations: {
                required: required,
                uniqueEmail: function (value) {
                    if (!value || value === '') return true

                    // 'this' points to the DataForm component (vuelidate.js.org/#sub-accessing-component)
                    const practitioner = this.modelInstance

                    return Api.findParticipants(null, value)
                        .then((items) => {
                            if (!practitioner.id) {
                                if (items.length > 0) {
                                    // will create practitioner on existing participant - warning
                                    this.warnings.email = 'MESSAGE_EMAIL_IN_USE_CREATE_PRACTITIONER_WARNING'
                                } else {
                                    // clear warning
                                    this.warnings.email = null
                                }
                                return true
                            } else {
                                if (items.length > 0 && items[0].id == practitioner.participant_id) {
                                    // this is the participant for the practitioner we're editing, so OK
                                    return true
                                } else if (items.length > 0) {
                                    // can't change practitioner's email to that of an existing participant
                                    return false
                                } else {
                                    return true
                                }
                            }
                        })
                }
            },
            invalidFeedback: { uniqueEmail: 'MESSAGE_EMAIL_IN_USE' }
        },
        firstname: {
            label: 'FIELD_PARTICIPANT_FIRSTNAME',
            type: 'text',
            validations: { required }
        },
        lastname: {
            label: 'FIELD_PARTICIPANT_LASTNAME',
            type: 'text',
            validations: { required },
        },
        role: {
            label: 'FIELD_PRACTITIONER_ROLE',
            type: 'select',
            options: {
                PHYSICIAN: 'FIELD_PRACTITIONER_ROLE_PHYSICIAN',
                MEDICAL_SPECIALIST: 'FIELD_PRACTITIONER_MEDICAL_SPECIALIST',
                NURSE_PRACTITIONER: 'FIELD_PRACTITIONER_ROLE_NURSE_PRACTITIONER',
                PHYSICIAN_ASSISTANT: 'FIELD_PRACTITIONER_ROLE_PHYSICIAN_ASSISTANT',
                NURSE_SPECIALIST: 'FIELD_PRACTITIONER_ROLE_NURSE_SPECIALIST',
                NURSE: 'FIELD_PRACTITIONER_ROLE_NURSE',
                MEDICAL_ASSISTANT: 'FIELD_PRACTITIONER_ROLE_MEDICAL_ASSISTANT',
                PRACTICE_MANAGER: 'FIELD_PRACTITIONER_ROLE_PRACTICE_MANAGER',
                WELLNESS_COACH: 'FIELD_PRACTITIONER_ROLE_WELLNESS_COACH',
                HEALTH_MENTOR: 'FIELD_PRACTITIONER_ROLE_HEALTH_MENTOR',
                DIETITIAN: 'FIELD_PRACTITIONER_ROLE_DIETITIAN',
                EXERCISE_SPECIALIST: 'FIELD_PRACTITIONER_ROLE_EXERCISE_SPECIALIST',
            },
        },
        title: {
            label: 'FIELD_PRACTITIONER_TITLE',
            type: 'text',
        },
        npi: {
            label: 'FIELD_PRACTITIONER_NPI',
            type: 'text',
        },
        practitioner_code_id: {
            label: 'FIELD_PRACTITIONER_CODE',
            type: 'typeahead',
            placeholder: 'FIELD_PRACTITIONER_CODE_PLACEHOLDER',
            getFieldObject: (practitioner) => {
                return practitioner.practitionerCode
            },
            typeaheadToString: (practitionerCode) => {
                if (practitionerCode) {
                    return `${practitionerCode.code} - ${practitionerCode.display_name}`
                } else {
                    return ''
                }
            },
            doTypeaheadSearch: (vue, modelInstance, searchText) => {
                const practitioner = modelInstance
                return vue.$api.findPractitionerCodes(vue, practitioner.role, searchText)
            },
        },
        emr_id: {
            label: 'FIELD_PRACTITIONER_EMR_ID',
            labelSlot: 'emr',
            type: 'text',
            validations: { maxLength: 127 },
        },
        receive_appointment_alert: {
            label: 'FIELD_PRACTITIONER_RECEIVE_APPOINTMENT_ALERT',
            type: 'check',
        },
        disabled: {
            label: 'FIELD_PRACTITIONER_DISABLED',
            type: 'check',
        },
    }
}
